import React, { useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { getHeaderTheme } from "../config/headerTheme";

const getIconPath = (type) => {
    return type === "star"
        ? "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
        : "M12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.68998C2 5.59998 4.49 3.09998 7.56 3.09998C9.38 3.09998 10.99 3.97998 12 5.33998C13.01 3.97998 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.59998 22 8.68998C22 15.69 15.52 19.82 12.62 20.81Z";
};

const theme = getHeaderTheme();

const Option = ({
    onSelect,
    label,
    id,
    iconType = "star",
    iconSize = 36,
    color = theme.accent
}) => {
    const [selected, setSelected] = useState(0);

    const handleIconClick = (value) => {
        const newValue = value === selected ? 0 : value;
        setSelected(newValue);
        onSelect(id, newValue);
    };

    return (
        <OptionSelect>
            <LabelText>{label}</LabelText>
            <HeartsRow>
                {[1, 2, 3, 4, 5].map((value) => (
                    <HeartIcon
                        key={value}
                        onClick={() => handleIconClick(value)}
                        filled={value <= selected}
                        color={color}
                        width={iconSize}
                        height={iconSize}
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d={getIconPath(iconType)}
                            stroke={color}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill={value <= selected ? color : "none"}
                        />
                    </HeartIcon>
                ))}
            </HeartsRow>
        </OptionSelect>
    );
};

export default Option;

// 🔹 Animaciones y estilos
const bounceIn = keyframes`
  0% {
    transform: scale(0.6);
    opacity: 0.6;
  }
  60% {
    transform: scale(1.25);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
`;

const OptionSelect = styled.div`
  margin: 1.5em 0;
  text-align: left;
  border-top: 0.8px solid #ccc;
  padding-top: 20px;
`;

const LabelText = styled.p`
  font-weight: 600;
  margin-bottom: 0.7em;
  font-size: 1rem;
`;

const HeartsRow = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0.5em;
`;

const HeartIcon = styled.svg`
  width: 36px;
  height: 36px;
  cursor: pointer;
  transition: transform 0.2s ease, fill 0.3s ease;

  &:hover {
    transform: scale(1.2);
  }

  ${(props) =>
        props.filled &&
        css`
      fill: ${props.color};
      animation: ${bounceIn} 0.3s ease;
    `}
`;